import {connect} from 'react-redux'
import * as ordersActions from "../actions/ordersActions";
import Orders from "../../Components/Orders/Orders";
import * as deliveryGroupsActions from "../actions/deliveryGroupsActions";

const mapStateToProps = (store) => {
    const props = {
        ...store.ordersReducer,
        proposedDeliveryGroups: store.deliveryGroupsReducer.proposedDeliveryGroups,
        assignedDeliveryGroups: store.deliveryGroupsReducer.assignedDeliveryGroups,
        evaluatingProposedDeliveryGroups: store.deliveryGroupsReducer.evaluatingProposedDeliveryGroups,
        sla: store.businessReducer.business.sla,
        isAreaSlaEnabled: store.businessReducer.business.isAreaSlaEnabled,
        urgentSla: store.businessReducer.business.urgentSla,
        readySla: store.businessReducer.business.readySla,
        isScheduleNotificationsEnabled: store.businessReducer.business.isScheduleNotificationsEnabled,
        orderStatusWhenAdded: store.businessReducer.business.orderStatusWhenAdded,
        placesOfDeparture: store.businessReducer.business.placesOfDeparture,
        isRedirect: !!store.businessReducer.business.integrationOrdersRedirection,
        isAutopilot: store.businessReducer.business.isAutopilot,
        scheduleReadyMinutesWhenAdded: store.businessReducer.business.scheduleReadyMinutesWhenAdded,
        isMerukazotEnabled: store.businessReducer.business.isMerukazotEnabled,
        lockedDeliveryGroups: store.deliveryGroupsReducer.lockedDeliveryGroups,
    };

    if (store.businessReducer.business.isDemo && store.businessReducer.business.dailyLimit >= 0)
        props.dailyLimit = store.businessReducer.business.dailyLimit;

    if (store.businessReducer.business.isMerukazotEnabled && store.businessReducer.business.merukazotMin >= 0)
        props.merukazotMin = store.businessReducer.business.merukazotMin;

    return props;
};

const mapDispatchToProps = {
    evaluateDeliveryGroups: deliveryGroupsActions.evaluateDeliveryGroupsAction,
    addOrder: ordersActions.addOrderAction,
    editOrder: ordersActions.editOrderAction,
    deleteOrder: ordersActions.deleteOrderAction,
    sendWithOrca: ordersActions.sendWithOrcaAction
};

const OrdersContainer = connect(mapStateToProps, mapDispatchToProps)(Orders);

export default OrdersContainer;